import {
  DELETE_PROVIDER_SUPERADMIN,
  DELETE_PROVIDER_SUPERADMIN_FAILURE,
  DELETE_PROVIDER_SUPERADMIN_SUCCESS,
} from './action';

const initialState = {
  loading: false,
  data: [],
  error: '',
};

const deleteProviderReducer = (state = initialState, action) => {
  switch (action.type) {
    case DELETE_PROVIDER_SUPERADMIN:
      return { ...state, loading: true };
    case DELETE_PROVIDER_SUPERADMIN_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: '' };
    case DELETE_PROVIDER_SUPERADMIN_FAILURE:
      return { ...state, loading: false, data: [], error: action.payload };
    default:
      return state;
  }
};

export default deleteProviderReducer;
